import Vue from 'vue';
import store from '@/store';

Vue.directive('mousetrap-off', {
  update: (el, binding) => {
    store.commit.application.setDialogOpen(!!binding.value);
  },
});
